import moment from "moment";

export interface PermintaanAntimikroba {
  id: number;
  register_id: number;
  pasien_rm: string | number;
  pasien_nama: string | null;
  ruang_rawat: string | null;
  items: { nama_antimikroba: string }[];
  dpjp: { id: number; nama: string } | null;
  signed_dpjp: boolean;
  status_alur: string;
  rekomendasi_kpra: string | null;
  dikirim_at: string | null;
  kpra_dicatat_at: string | null;
}

export const STATUS_ALUR: Record<string, { label: string; color: string }> = {
  draft: { label: "Belum Dikirim", color: "grey" },
  menunggu_kpra: { label: "Menunggu KPRA", color: "orange" },
  menunggu_verifikasi: { label: "Menunggu Verifikasi", color: "blue" },
  terverifikasi: { label: "Terverifikasi", color: "green" }
};

export function statusAlur(status: string) {
  return STATUS_ALUR[status] || STATUS_ALUR.draft;
}

export function formatWaktu(nilai: string | null) {
  return nilai ? moment(nilai, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm") : "-";
}
